import { __decorate, __metadata } from "tslib";
import Cookie from 'js-cookie';
import { Vue, Component, Inject } from 'vue-property-decorator';
import { getLevelDomain } from 'library-components/utils/url';
import { setLangValue } from 'library-components/utils/langUtils';
import { setLoginLocaleStatus } from 'library-components/services/localStorage';
import PtSelectLanguage from '@patsnap-biz/select-language';
import { makeLanguages } from '@/infrastructure/utils/lang';
const POLICY_COOKIE_ALERT_KEY = 'is-cookie-alert-closed';
let MainFrameImpl = class MainFrameImpl extends Vue {
    commonService;
    hasPolicy = Cookie.get(POLICY_COOKIE_ALERT_KEY) !== 'true';
    onClosePolicy() {
        this.hasPolicy = false;
        const TopLevelDomain = getLevelDomain(window.location.hostname);
        Cookie.set(POLICY_COOKIE_ALERT_KEY, 'true', {
            expires: 1000000, path: '/', domain: TopLevelDomain,
        });
    }
    languages = makeLanguages(this.$i18n.locale);
    onLanguageChange(language) {
        setLangValue(language, false).then(() => {
            setLoginLocaleStatus();
            window.location.reload();
        });
    }
};
__decorate([
    Inject('commonService'),
    __metadata("design:type", Object)
], MainFrameImpl.prototype, "commonService", void 0);
MainFrameImpl = __decorate([
    Component({
        name: 'MainFrame',
        components: {
            Carousel: () => import('@/presentation/components/Carousel/Carousel.vue'),
            LoginPanel: () => import('@/presentation/components/LoginPanel/LoginPanel.vue'),
            PolicyFooter: () => import('@/presentation/components/PolicyFooter/PolicyFooter.vue'),
            PtSelectLanguage,
        },
    })
], MainFrameImpl);
export { MainFrameImpl };
